export default "__VITE_ASSET__B1H$4rxv__"